<template>
  <PageHeader pageTitle="პროფილი" />
  <div class="container mb-5 mt-5">
    <div class="profile-page border">
      <div class="row g-0">
        <div class="col-3 border-end">
          <div class="my-4">
            <div
              class="
                user-avatar-lg
                d-flex
                align-items-center
                justify-content-center
                rounded-circle
                mx-auto
                mb-3
                bg-secondary
              "
            >
              <span>{{ userInitials }}</span>
            </div>
            <div class="fw-bold text-center mb-1">{{ fullname }}</div>
            <div class="text-center small text-secondary">{{ email }}</div>
          </div>
          <ProfilePageMenu />
        </div>

        <router-view
          :user="user"
          :store="store"
          name="ProfileSettings"
        ></router-view>
        <router-view :store="store"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import ProfilePageMenu from "@/components/ProfilePageMenu.vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { computed, watchEffect } from "@vue/runtime-core";
import useFullname from "@/composables/useFullname";
import useUserInitials from "@/composables/useUserInitials";

export default {
  components: { PageHeader, ProfilePageMenu },
  setup() {
    const email = ref(null);
    const fullname = ref(null);
    const userInitials = ref(null);

    const store = useStore();

    const user = computed(() => {
      return store.state.user;
    });

    email.value = user.value.email;

    watchEffect(() => {
      fullname.value = useFullname(user.value.firstname, user.value.lastname);
      userInitials.value = useUserInitials(
        user.value.firstname,
        user.value.lastname
      );
    });

    return {
      fullname,
      userInitials,
      email,
      user,
      store,
    };
  },
};
</script>

<style>
.user-avatar-lg {
  width: 144px;
  height: 144px;
  /* background-color: #4f75a6; */
}
.user-avatar-lg span {
  color: #fff;
  font-size: 2rem;
}
</style>